import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import DoneIcon from '@mui/icons-material/Done';
import CircularProgress from '@mui/material/CircularProgress';
import { Link } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import AsyncSelect from 'react-select/async';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { fetchData, updateData, postData } from '../../../apiService';
import DeleteIcon from '@mui/icons-material/Delete';
import { Button, Tooltip } from '@material-ui/core';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import SaveAsIcon from '@mui/icons-material/SaveAs';
import Modal from '@mui/material/Modal';
import { FaTimes } from 'react-icons/fa'; // Example for FontAwesome Icon
import AsyncCreatableSelect from 'react-select/async-creatable';
import { useLocation } from 'react-router-dom';
import Select from "react-select"; // regular select

const PurchaseDetails = () => {
    const { id } = useParams(); // Use useParams to get the id from the URL  
    const [selectedItems, setSelectedItems] = useState([]);
    const { isAuthenticated, companyId, branchId, userId, permissions, token, logout, branchstate } = useAuth();
    const [formData, setFormData] = useState([]);
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        // Check if reload is needed based on the flag set in localStorage
        const shouldReload = localStorage.getItem('shouldReloadCreatePage') === 'true';

        if (shouldReload) {
            localStorage.removeItem('shouldReloadCreatePage'); // Remove the flag after use
            window.location.reload(); // Reload the page once
        }

        // Authentication and token expiration handling
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

        // Other initializations, if any
    }, [isAuthenticated, companyId, branchId, userId, token, logout]);
    const [purchaseId, setpurchaseId] = useState("");

    useEffect(() => {
        fetchData('PurchaseApi', `/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setFormData(response.response_data.Purchase);
                    setpurchaseId(response.response_data.Purchase.Id);
                    setSelectedItems(response.response_data.PurchaseDetails);
                }
            })
            .catch((error) => {
                console.error('Error fetching Sale Details:', error);
            });
    }, [id]);

    //handle search [ITEM SEARCH]   
    const [searchQuery, setSearchQuery] = useState('');
    //search
    const filteredData = selectedItems.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;

        return formattedDate;
    };


    return (
        <div
            style={{
                fontFamily: "Segoe UI, sans-serif",
                fontSize: "12px",
                width: "100%",
                padding: "5px",
                marginTop: '-10px'
            }}
        >
            {/* Header */}
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderBottom: "1px solid #ccc",
                    paddingBottom: "6px",
                    marginBottom: "12px"
                }}
            >
                <h6 className="uppercase tracking-wide font-serif text-black mt-2">
                    Purchase  Details
                </h6>
                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "300px repeat(3, 1fr)",
                        gap: "10px",
                        marginBottom: "12px",
                        alignItems: "end",
                    }}
                >
                    <div style={{ display: "flex", alignItems: "center", width: "300px" }}>
                        {/* Label + Type */}
                        <label style={{
                            fontSize: "11px",
                            fontWeight: "600",
                            marginRight: "8px",
                            whiteSpace: "nowrap"
                        }}>
                            Supplier
                            <span style={{ color: "black", marginLeft: "8px" }}>
                                (Type : {formData.InvoiceTypeName})
                            </span>
                        </label>

                        {/* Input */}
                        <div style={{ flexGrow: 1 }}>

                            <input
                                type="text"
                                name="SupplierName"
                                value={formData.SupplierName}
                                style={{
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    fontSize: "12px",
                                    height: "28px",
                                    width: "300px", // updated width
                                    padding: "0 6px"
                                }}
                            />

                        </div>
                    </div>

                </div>
              
                <div className="flex items-center gap-3 mt-2 md:mt-0" style={{ flexShrink: 0 }}>
                    {/* Back To List Button */}
                    <Button
                        variant="contained"
                        component={Link}
                        to="/PurchaseIndex"
                        className="linkcolor"
                        onClick={() => localStorage.setItem("shouldReload", "true")}
                        style={{
                            height: "25px",
                            minWidth: "90px",
                            borderRadius: "6px",
                            backgroundColor: "#F3F4F6", // light gray ERP style
                            color: "#1E3A8A",
                            fontWeight: 600,
                            fontSize: "13px",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                            textTransform: "none",
                            transition: "background-color 0.2s, box-shadow 0.2s",
                        }}
                        onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#E5E7EB")}
                        onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#F3F4F6")}
                    >
                        Back To List
                    </Button>
                </div>
            </div>

            {/* Top Section - Supplier & Bill */}
            {errorMessage && <p className="text-red-500">{errorMessage}</p>}
            <div
                style={{
                    display: "grid",
                    // gridTemplateColumns: "250px repeat(7, 1fr)", 
                    gridTemplateColumns: "repeat(10, 1fr)",
                    gap: "10px",
                    marginBottom: "12px",
                    alignItems: "end" // ✅ aligns all inputs properly
                }}
            >
                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Bill Date</label>
                    <input
                        type="date"
                        name="BillDate"
                        value={formatDateForInput(formData.BillDate)}
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px"
                        }}
                        readOnly
                    />
                </div>
                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>
                        Bill Number
                    </label>
                    <input
                        type="text"
                        name="BillNumber"
                        value={formData.BillNumber}
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px"
                        }}
                        readOnly
                    />
                </div>
                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>
                        Clearing Date
                    </label>
                    <input
                        type="date"
                        name="ClearingDate"
                        value={formatDateForInput(formData.ClearingDate)}
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px"
                        }}
                        readOnly
                    />
                </div>
                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Freight
                        <span style={{ color: 'darkmagenta', marginLeft: '10px' }}>({formData.FreightGSTRate}%)</span>
                        <span style={{ color: 'red', marginLeft: '10px' }}>{formData.FreightGSTAmount}</span>
                    </label>
                    <input
                        type="number"
                        name="FreightAmount"
                        value={formData.FreightAmount}
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right"
                        }}
                        readOnly
                    />
                </div>
                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Packing
                        <span style={{ color: 'darkmagenta', marginLeft: '10px' }}> ({formData.PackingGSTRate}%)</span>
                        <span style={{ color: 'red', marginLeft: '10px' }}>{formData.PackingGSTAmount}</span>
                    </label>
                    <input
                        type="number"
                        name="PackingAmount"
                        value={formData.PackingAmount}
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right"
                        }}
                        readOnly
                    />
                </div>

                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>TCS</label>
                    <input
                        type="number"
                        name="TCSAmount"
                        value={formData.TCSAmount}
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right"
                        }}
                        readOnly
                    />
                </div>

                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Round Off</label>
                    <input
                        type="number"
                        name="RoundOff"
                        value={formData.RoundOff}
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right"
                        }}
                        readOnly
                    />
                </div>
                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Total</label>
                    <input
                        type="number"
                        name="TotalAmount"
                        value={formData.TotalAmount}
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right",
                            fontWeight: "bold",
                            color: "#0D47A1"
                        }}
                        readOnly
                    />
                </div>
                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Cash</label>
                    <input
                        value={formData.PaidAmount}
                        type="number"
                        placeholder="PaidAmount"
                        name='PaidAmount'
                        max={formData.TotalAmount}
                        min="0"
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right",
                            fontWeight: "bold",
                            color: "#0D47A1"
                        }}
                        readOnly
                    />
                </div>
                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Balance</label>
                    <input
                        value={formData.BalanceAmount}
                        type="text"
                        placeholder="BalanceAmount"
                        style={{
                            textAlign: 'right',
                            color: formData.BalanceAmount > 0 ? 'red' : 'inherit',// Sets color to red if BlanceAmount > 0
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right",
                            fontWeight: "bold",
                            //color: "#0D47A1"
                        }}
                        name='BalanceAmount'
                        readOnly
                    />
                </div>
                {/* </div> */}
            </div>

            {/* Amount Summary */}
            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(6, 1fr)",
                    gap: "8px",
                    marginBottom: "12px",
                    fontSize: "12px"
                }}
            >
                <div>
                    Amount:{" "}
                    <span style={{ color: "#B71C1C", fontWeight: "bold" }}>
                        {formData.Amount}
                    </span>
                </div>
                <div>
                    Discount:{" "}
                    <span style={{ color: "#B71C1C", fontWeight: "bold" }}>
                        {formData.DiscountAmount}
                    </span>
                </div>
                <div>
                    Taxable:{" "}
                    <span style={{ color: "#B71C1C", fontWeight: "bold" }}>
                        {formData.TaxableAmount}
                    </span>
                </div>
                <div>
                    CGST: <span style={{ color: "#B71C1C", fontWeight: "bold" }}>{formData.CGSTAmount}</span>
                </div>
                <div>
                    SGST: <span style={{ color: "#B71C1C", fontWeight: "bold" }}>{formData.SGSTAmount}</span>
                </div>
                <div>
                    IGST: <span style={{ color: "#B71C1C", fontWeight: "bold" }}>{formData.IGSTAmount}</span>
                </div>
            </div>

            {/* Data Table */}
            <div
                style={{
                    maxHeight: "300px",
                    overflowY: "auto",
                    marginBottom: "12px",
                    border: "1px solid #999",
                    borderRadius: "4px",
                    backgroundColor: "#fff",
                }}
            >
                <table
                    style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        fontSize: "13px",
                        fontFamily: "monospace",
                    }}
                >
                    <thead style={{ backgroundColor: "#1F2A38", color: "#FFFFFF" }}>
                        <tr>
                            {[
                                "SL.No",
                                "Item",
                                "Qty",
                                "Rate",
                                "Amount",
                                "Disc%",
                                "Disc₹",
                                "Taxable",
                                "GST₹",
                                "Total",
                            ].map((header, idx) => (
                                <th
                                    key={idx}
                                    style={{
                                        padding: "3px",
                                        //textAlign: idx > 1 & 9 ? "right" : "left",
                                        textAlign: idx > 1 ? "center" : "left",
                                        borderBottom: "1px solid #ccc",
                                        textTransform: 'uppercase',
                                        fontSize: '10px'
                                    }}                                >
                                    {header}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {filteredData.map((item, index) => (
                            <tr
                                key={index}
                                style={{
                                    backgroundColor: index % 2 === 0 ? "#FDFDFD" : "#F5F7FA",
                                    borderBottom: "1px solid #ddd",
                                }}
                            >
                                {/* SL.No + Delete */}
                                <td style={{ padding: "4px 6px", textAlign: "center" }}>
                                    {index + 1}
                                </td>

                                {/* Item Name */}
                                <td
                                    style={{
                                        fontSize: "13px",
                                        //fontWeight: "bold",
                                        padding: "4px",
                                        minWidth: "200px",
                                    }}
                                >
                                    {item.ItemName}
                                </td>

                                {/* Quantity */}
                                <td style={{ padding: "2px", textAlign: "right", width: "70px" }}>
                                    <input
                                        type="number"
                                        value={item.Quantity}
                                        name="Quantity"
                                        style={{
                                            width: "100%",
                                            textAlign: "right",
                                            //backgroundColor: "#ECFAE5",
                                            //fontWeight: "bold",
                                            border: "1px solid #bbb",
                                            borderRadius: "3px",
                                            padding: "2px",
                                        }}
                                        readOnly
                                    />
                                </td>

                                {/* Rate */}
                                <td style={{ padding: "2px", textAlign: "right", width: "120px" }}>
                                    <input
                                        type="number"
                                        value={item.Rate || 0}
                                        name="Rate"
                                        style={{
                                            width: "100%",
                                            textAlign: "right",
                                            //backgroundColor: "#F6D6D6",
                                            //fontWeight: "bold",
                                            border: "1px solid #bbb",
                                            borderRadius: "3px",
                                            padding: "2px",
                                        }}
                                        readOnly
                                    />
                                </td>

                                {/* Amount */}
                                <td style={{ padding: "2px", textAlign: "right", width: "120px" }}>
                                    <input
                                        value={item.Amount || 0}
                                        readOnly
                                        style={{
                                            width: "100%",
                                            textAlign: "right",
                                            border: "1px solid #ccc",
                                            //backgroundColor: "#fdfdfd",
                                            padding: "2px",
                                            borderRadius: "3px",
                                            //fontWeight: "bold",
                                        }}
                                    />
                                </td>

                                {/* Discount % */}
                                <td style={{ padding: "2px", textAlign: "right", width: "120px" }}>
                                    <input
                                        type="number"
                                        value={item.DiscountPercentage || 0}
                                        name="DiscountPercentage"
                                        style={{
                                            width: "100%",
                                            textAlign: "right",
                                            //backgroundColor: "#F2EFE7",
                                            border: "1px solid #bbb",
                                            borderRadius: "3px",
                                            padding: "2px",
                                            //fontWeight: "bold",
                                        }}
                                        readOnly
                                    />
                                </td>

                                {/* Discount Amount */}
                                <td style={{ padding: "2px", textAlign: "right", width: "120px" }}>
                                    <input
                                        value={item.DiscountAmount || 0}
                                        readOnly
                                        style={{
                                            width: "100%",
                                            textAlign: "right",
                                            border: "1px solid #ccc",
                                            borderRadius: "3px",
                                            padding: "2px",
                                            //fontWeight: "bold",
                                        }}
                                    />
                                </td>

                                {/* Taxable */}
                                <td style={{ padding: "2px", textAlign: "right", width: "120px" }}>
                                    <input
                                        value={item.TaxableAmount || 0}
                                        readOnly
                                        style={{
                                            width: "100%",
                                            textAlign: "right",
                                            border: "1px solid #ccc",
                                            borderRadius: "3px",
                                            padding: "2px",
                                            //fontWeight: "bold",
                                        }}
                                    />
                                </td>

                                {/* GST */}
                                <td style={{ padding: "2px", textAlign: "right", width: "120px" }}>
                                    <input
                                        value={
                                            parseFloat(item.CGSTAmount) +
                                            parseFloat(item.SGSTAmount) +
                                            parseFloat(item.IGSTAmount)
                                        }
                                        readOnly
                                        style={{
                                            width: "70%",
                                            textAlign: "right",
                                            border: "1px solid #ccc",
                                            borderRadius: "3px",
                                            padding: "2px",
                                            // fontWeight: "bold",
                                        }}
                                    />
                                    <span
                                        style={{
                                            marginLeft: "4px",
                                            color: "darkmagenta",
                                            fontSize: "11px",
                                            //fontWeight: "bold",
                                        }}
                                    >
                                        {item.GSTRate ? parseFloat(item.GSTRate) : 0}%
                                    </span>
                                </td>

                                {/* Total */}
                                <td style={{ padding: "2px", textAlign: "right", width: "120px" }}>
                                    <input
                                        value={item.TotalAmount || 0}
                                        readOnly
                                        style={{
                                            width: "100%",
                                            textAlign: "right",
                                            //backgroundColor: "#DDE9EC",
                                            border: "1px solid #888",
                                            borderRadius: "3px",
                                            padding: "2px",
                                            fontWeight: "bold",
                                            color: 'brown'
                                        }}
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>



            {/* Extra Charges + Remarks */}
            <div>
                <label style={{ fontSize: "11px", fontWeight: "600" }}>Remarks</label>
                <textarea
                    name="Remarks"
                    value={formData.Remarks}
                    rows={2}
                    style={{
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        fontSize: "12px",
                        width: "100%",
                        padding: "4px"
                    }}
                    readOnly
                />
            </div>
        </div>
    );
}
export default PurchaseDetails;
